window.pdfjsLib = window.pdfjsLib || {};

/* Constants */
export const validImageExtensions = [
  "image/jpg",
  "image/jpeg",
  "image/gif",
  "image/png",
];

export const getFileExtension = (fileName) => {
  const re = /(?:\.([^.]+))?$/;
  return re.exec(fileName);
};

// make base64 image form file object
export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

/* eslint-disable import/prefer-default-export */
export const getPDFPreviewURL = async (file, scale = 1.5) => {
  if (!file || file.type !== "application/pdf") {
    console.error("Invalid file type. Please provide a valid PDF file.");
    return null;
  }

  try {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
      fileReader.onload = async (event) => {
        if (!event.target?.result) {
          reject(new Error("Failed to read the PDF file."));
          return;
        }

        const typedArray = new Uint8Array(event.target.result);

        if (!window.pdfjsLib) {
          reject(new Error("PDF.js library is not available in the browser."));
          return;
        }

        const pdf = await window.pdfjsLib.getDocument(typedArray).promise;
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (!context) {
          reject(new Error("Failed to get 2D context."));
          return;
        }

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: context, viewport };
        await page.render(renderContext).promise;

        resolve(canvas.toDataURL("image/png"));
      };

      fileReader.onerror = () => reject(new Error("Error reading the file."));
      fileReader.readAsArrayBuffer(file);
    });
  } catch (error) {
    console.error("Error generating PDF preview:", error);
    return null;
  }
};

export const reorderItemInList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
